export default {
  formRules: {
    decreaseOverflowType: [
      {
        required: true,
        message: window.vm.$t('lossOverflowReport.search.decreaseOverflowTypePlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    storageNo: [
      {
        required: true,
        message: window.vm.$t('lossOverflowReport.search.storageNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    decreaseOverflowDepartmentName: [
      {
        required: true,
        message: window.vm.$t('lossOverflowReport.search.decreaseOverflowDepartmentNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
  },
  productRules: {
    batchNo: [
      {
        required: true,
        message: window.vm.$t('lossOverflowReport.goodList.batchNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    decreaseOverflowQuantity: [
      {
        required: true,
        message: window.vm.$t('lossOverflowReport.goodList.decreaseOverflowQuantityPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
  },
};
